// File Metadata:
// Filename: theme.js
// Version: 1.00
// Created: 2022-10-15 02:29:46
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { createTheme } from '@mui/material'

export const theme = createTheme({
	palette: {
		type: 'light',
		primary: {
			main: '#005ca9'
		},
		secondary: {
			main: '#f50057'
		},
		background: {
			paper: '#e0e0e0',
			default: '#292929'
		}
	},
	props: {
		MuiList: {
			dense: true
		},
		MuiMenuItem: {
			dense: true
		},
		MuiListButton: {
			dense: true
		},
		MuiTable: {
			size: 'small'
		},
		MuiCard: {},
		MuiCardHeader: {
			bgColor: '#005ca9'
		}
	}
})
